// extracted by mini-css-extract-plugin
module.exports = {"brandTrendingWrap":"iq-z"};